import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80df8068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-relocation" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "create-relocation__form" }
const _hoisted_5 = { class: "text-sm text-gray-400" }
const _hoisted_6 = { class: "text-sm text-gray-400" }
const _hoisted_7 = {
  key: 0,
  class: "text-lg font-semibold mt-6"
}
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_11 = { class: "create-relocation__form" }
const _hoisted_12 = { class: "text-lg font-semibold" }
const _hoisted_13 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-3 items-start" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_16 = { class: "flex items-center justify-end mt-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Редактирование перемещения" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/tmc/relocations')))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_input, {
        disabled: _ctx.state.is_loading,
        placeholder: "Номер заявки JIRA",
        value: _ctx.state.jiraNumber,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.jiraNumber) = $event)),
        "is-invalid": _ctx.state_validation.jiraNumber.$error,
        "validation-errors": _ctx.state_validation.jiraNumber.$errors
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-4",
        placeholder: "Склад (откуда)",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_validation.fromWarehouseId.$error,
        "validation-errors": _ctx.state_validation.fromWarehouseId.$errors,
        loading: _ctx.data_state.warehouses.is_loading,
        failed: _ctx.data_state.warehouses.is_failed,
        "error-text": "При получении списка складов произошла ошибка",
        options: _ctx.data_state.warehouses.list,
        value: _ctx.state.fromWarehouseId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.fromWarehouseId) = $event)),
        "search-by": "city",
        onRefresh: _ctx.loadWarehouses
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(" Склад " + _toDisplayString(option.city), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, "Склад " + _toDisplayString(option.city), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(option.full_address), 1)
          ])
        ]),
        _: 1
      }, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-4",
        placeholder: "Склад (куда)",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_validation.toWarehouseId.$error,
        "validation-errors": _ctx.state_validation.toWarehouseId.$errors,
        loading: _ctx.data_state.second_warehouses.is_loading,
        failed: _ctx.data_state.second_warehouses.is_failed,
        "error-text": "При получении списка складов произошла ошибка",
        options: _ctx.data_state.second_warehouses.list,
        value: _ctx.state.toWarehouseId,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.toWarehouseId) = $event)),
        "search-by": "city",
        onRefresh: _ctx.loadSecondWarehouses
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(" Склад " + _toDisplayString(option.city), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, "Склад " + _toDisplayString(option.city), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(option.full_address), 1)
          ])
        ]),
        _: 1
      }, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"])
    ]),
    (Boolean(_ctx.state.items.length))
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Товары (" + _toDisplayString(_ctx.state.items.length) + ") ", 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "px-4 py-3 mt-3 bg-white border flex items-center justify-between",
        key: `item-${i}`
      }, [
        _createElementVNode("p", null, "ТМЦ: " + _toDisplayString(item.tmc_name) + ", количество: " + _toDisplayString(item.amount), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_the_button, {
            disabled: _ctx.state.is_loading,
            class: "yellow text small",
            onClick: ($event: any) => (_ctx.startEditItem(i))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_the_button, {
            disabled: _ctx.state.is_loading,
            loading: _ctx.state.is_item_removing,
            class: "red text small",
            onClick: ($event: any) => (_ctx.removeItem(i))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 2
          }, 1032, ["disabled", "loading", "onClick"])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", _hoisted_12, [
        (_ctx.item_state.is_update)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Редактирование товара")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Добавление товара")
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_the_select, {
          class: "mt-2",
          disabled: _ctx.state.is_loading,
          placeholder: "ТМЦ",
          "is-invalid": _ctx.item_validation.tmc.$error,
          "validation-errors": _ctx.item_validation.tmc.$errors,
          loading: _ctx.data_state.tmc.is_loading,
          failed: _ctx.data_state.tmc.is_failed,
          "error-text": "При получении списка компаний произошла ошибка",
          options: _ctx.data_state.tmc.list,
          value: _ctx.item_state.tmc,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item_state.tmc) = $event)),
          "infinite-scroll": "",
          "search-by": "name",
          onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadTMC(_ctx.data_state.tmc.pagination.current_page))),
          onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreTMC(_ctx.data_state.tmc.pagination.current_page + 1))),
          onSearch: _ctx.searchTMC,
          onOptionBySearch: _ctx.unshiftFindedTMC
        }, null, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_input, {
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.item_validation.amount.$error,
          "validation-errors": _ctx.item_validation.amount.$errors,
          placeholder: "Количество",
          value: _ctx.item_state.amount,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item_state.amount) = $event))
        }, null, 8, ["disabled", "is-invalid", "validation-errors", "value"]),
        (_ctx.item_state.is_update)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              class: "primary text small mt-2 py-3",
              disabled: _ctx.state.is_loading,
              onClick: _ctx.editItem
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              class: "primary text small mt-2 py-3",
              disabled: _ctx.state.is_loading,
              onClick: _ctx.addItem
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_the_button, {
        class: "primary small",
        disabled: _ctx.state.is_relocation_failed,
        loading: _ctx.state.is_loading || _ctx.state.is_relocation_loading,
        onClick: _ctx.submitForm
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createTextVNode(" Сохранить заявку на перемещение ")
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ])
  ]))
}